<template>
  <f7-page name="Calendar" class="calendar-page dark-page">
    <f7-navbar title="Calendar" back-link="Back">
      <f7-nav-right>
        <f7-link  href="/" class="menu-icon"><i class="az-icon-home-house-interface-ui-website"></i></f7-link>
      </f7-nav-right>
    </f7-navbar>

      <f7-row>
        <div class="col-40 col-sm-0">
          <div class="left-az-logo">
            <img src="../assets/images/left-logo.png" alt="" />
          </div>
        </div>
        <div class="col-60 col-sm-100">
                <div class="calendar-content">
        <calendar @dayclick="dayClickHandlr" :attributes="attrs" ref="calendar"></calendar>
      </div>
    
      <div v-if="currentEvents.length" v-for="event in currentEvents" :key="event.id">
        <div class="calender-name">
          <!-- <h2>17 October - Novotal Nasr City</h2> -->
          <h3>{{ formateDate(event) }} - {{ event.venue }}, {{ event.location }}</h3>
          <p>{{ event.title }}</p>
        </div>

        <!-- Feedback Button-->
        <div class="calender-button">
          <div class="row">
            <f7-col width="15"></f7-col>
            <f7-col width="70">
              <a href="#" @click.prevent="showDetails(event)" class="button button-fill button-round">More Details</a>
            </f7-col>
            <f7-col width="15"></f7-col>
          </div>
        </div>
      </div>

        </div>
      </f7-row>



  </f7-page>
</template>
<script>
export default {
  data() {
    return {
      events: [],
      attrs: [],
      currentEvents: [],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    }
  },
  methods: {
    dayClickHandlr: function(data) {
      this.currentEvents = this.events.filter( (item) => {
        return item.event_time.search(data.id) > -1
      })

      // this.currentEvents.map( (item) => {
      //   var d = new Date(item.event_time)
      //   item.event_time = d.getDate() + ' ' + this.months[d.getMonth()]
      // })
    },
    showDetails(event) {
      sessionStorage.setItem('currentEvent', JSON.stringify(event))
      this.$f7.view.current.router.navigate( '/event-details/'+ event.id )
    },
    formatAMPM(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    formateDate: function(event) {
      var d = new Date(event.event_time.replace(/-/g, "/"))
      return d.getDate() + ' ' + this.months[d.getMonth()] + ' ' + this.formatAMPM(new Date(event.event_time.replace(/-/g, "/")))
    }
  },
  mounted: function() {
    this.$f7.preloader.show()
    this.$http.get( this.$root.apiBaseURL + 'events' )
      .then( (res) => {
        this.$f7.preloader.hide()
        this.events = res.data.events
        this.events.map( (item) => {
          this.attrs.push({
            key: item.id,
            highlight: 'pink',
            dates: new Date(item.event_time.replace(/-/g, "/"))
          })
          this.$refs.calendar.refreshAttrs()
        })
      })
      .catch( (err) => {
        this.$f7.preloader.hide()
        console.log(err)
      })
  }
}
</script>
<style scoped>
  .menu-icon i::before {
    color: #870047;
    font-size: 35px;
  }
</style>
